import { Accordion, Container, Carousel } from "@peracto/peracto-blocks";

export default {
    plugins: {
        content: [Accordion, Carousel],
        layout: [Container],
    },
};
